import counterUp from 'counterup2';

const $ = jQuery.noConflict();

'use strict';
const counterNumber = {
	$domCounter: document.querySelectorAll('.js-counter-number'),
	$domCounterWrap: $('.js-counter-wrapper'),
	$domCounterCol: $('.js-counter-col'),
	$domCounterShape: $('.js-counter-shape'),

	init: function() {
		if (counterNumber.$domCounter) {
			this.count();
			this.counterHeight();
		}
	},

	count: () => {
		const callback = entries => {
			entries.forEach(entry => {
				const el = entry.target;
				if (entry.isIntersecting && !el.classList.contains('is-visible')) {
					counterUp(el, {
						duration: 3000,
						delay: 15,
					});
					el.classList.add('is-visible');
				}
			});
		};

		const IO = new IntersectionObserver(callback, {
			threshold: 1
		});

		counterNumber.$domCounter.forEach(el => {
			IO.observe(el);
		});
	},

	counterHeight: function() {
		if ($(window).width() > 991) {
			setTimeout(() => {
				const height = counterNumber.$domCounterShape.height();
				counterNumber.$domCounterWrap.css('min-height', height);
			}, 50);
		}

		$(window).resize(function() {
			if ($(window).width() < 991) {
				counterNumber.$domCounterWrap.css('min-height', 0);
			}
			if ($(window).width() > 991) {
				const height = counterNumber.$domCounterShape.height();
				counterNumber.$domCounterWrap.css('min-height', height);
			}
		});
	}
};
export default counterNumber;
